import { render, staticRenderFns } from "./Receipt-header.vue?vue&type=template&id=2e47d5e0"
import script from "./Receipt-header.vue?vue&type=script&lang=js"
export * from "./Receipt-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports